import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';

@Pipe({
    name: 'getHeight',
    pure: false,
})
export class GetHeightPipe implements PipeTransform {
    private lastHeight: number;
    constructor(private readonly ref: ChangeDetectorRef) {}

    transform(scrollViewPort: CdkVirtualScrollViewport): number {
        const spacerElement = scrollViewPort?.elementRef?.nativeElement?.getElementsByClassName(
            'cdk-virtual-scroll-spacer'
        )[0] as HTMLElement;

        if (spacerElement.clientHeight === this.lastHeight) {
            return this.lastHeight;
        }

        of(spacerElement.clientHeight)
            .toPromise()
            .then((newHeight: number) => {
                if (newHeight !== this.lastHeight) {
                    this.lastHeight = newHeight;
                }
            });

        return this.lastHeight;
    }
}
